import axios from "axios";
import store from "../redux/store/store";
import { logout } from "../redux/action/auth_action";

// const baseURL = "https://labs.medicitylab.co/api/v1";
//const baseURL = "https://be.aarggvtech.com/api/v1/";
const baseURL = "https://labs.medicitylab.co/api/v1";
// const baseURL = process.env.REACT_APP_BASE_BACKEND_API_URL

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      if (status === 401 || status === 403) {
        setTimeout(() => {
          store.dispatch(logout());
        }, 2000);
      }
    }

    return Promise.reject(error);
  },
);

if (localStorage.getItem("zone_id")) {
  axiosInstance.defaults.headers.common["x-custom-zone-id"] =
    localStorage.getItem("zone_id");
}
if (localStorage.getItem("franchise_id")) {
  axiosInstance.defaults.headers.common["x-custom-franchise-id"] =
    localStorage.getItem("franchise_id");
}
if (localStorage.getItem("is_super_franchise")) {
  axiosInstance.defaults.headers.common["x-custom-is-super-franchise"] =
    localStorage.getItem("is_super_franchise");
}
if (localStorage.getItem("is_franchise_employee")) {
  axiosInstance.defaults.headers.common["x-custom-is-franchise-employee"] =
    localStorage.getItem("is_franchise_employee");
}

export default axiosInstance;
